<div class="simple-card">
  <page-title></page-title>
</div>

<div class="m-t-20">
  <h3>{{ 'quotes.productFinder' | cxTranslate }}</h3>

  <product-finder></product-finder>
</div>

<div class="m-t-20">
  <h3>{{ 'quotes.quotationForm' | cxTranslate }}</h3>

  <div class="simple-card">
    <quotation-form></quotation-form>
  </div>
</div>

<div class="m-t-20">
  <h3>{{ 'quotes.generalInformation' | cxTranslate }}</h3>

  <div class="simple-card">
    <general-information [form]="formGeneralInformations!"></general-information>

    <div class="actions">
      <button type="button" class="btn btn-primary" (click)="submitQuote()">
        <span class="material-symbols-outlined d-flex m-r-4"> request_quote </span>{{ 'quotes.submit' | cxTranslate }}
      </button>
    </div>
  </div>
</div>